import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

import type { CampaignQaResult } from "./types";

export const isCampaignQaResult = objectOf<CampaignQaResult>({
  status: number,
  agent_results: maybe(
    arrayOf(
      objectOf({
        agent_id: string,
        qa_results: maybe(
          arrayOf(
            objectOf({
              rule: string,
              status: string,
              reason: string,
              ruleset_name: maybe(string),
            })
          )
        ),
        execution_time_ms: maybe(number),
        error_code: maybe(string),
        error_message: maybe(string, true),
      })
    )
  ),
  execution_time_ms: maybe(number),
  error_code: maybe(string),
  chunked_result_complete: maybe(boolean),
  run_request_id: maybe(string),
});
